<template>
	<div class="flex justify-around flex-wrap content">
		<div class="item flex flex-direction align-center justify-center">
			<img :src="item.image" alt="" v-for="(item, index) in book.items" :key="index" :preview="item.image" />
		</div>
	</div>
</template>

<script>
export default {
	computed: {},
	props: {
		book: Object
	},
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
.content {
	margin: -0.2rem -0.3rem;
}
.item {
	width: 7.5rem;
	background: #fff;
	img {
		width: 100%;
		border-bottom: 0.02rem solid rgba($color: #000000, $alpha: 0.2);
		box-shadow: 0 0 0.4rem rgba($color: #000000, $alpha: 0.2);
	}
}
</style>
